import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=0ca520cd&scoped=true&"
import script from "./Totals.vue?vue&type=script&lang=ts&"
export * from "./Totals.vue?vue&type=script&lang=ts&"
import style0 from "./Totals.vue?vue&type=style&index=0&id=0ca520cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca520cd",
  null
  
)

export default component.exports